import { createFeatureSelector, MemoizedSelector } from '@ngrx/store';
import { StateWithWishlist, WISHLIST_FEATURE, WishlistState } from '../wishlist-state';

export const getWishlistState: MemoizedSelector<StateWithWishlist, WishlistState> =
  createFeatureSelector<WishlistState>(WISHLIST_FEATURE);
